
export interface ExportColumn {
  key: string;
  header: string;
  width?: number;
  alignment?: 'left' | 'center' | 'right';
  format?: 'text' | 'number' | 'currency' | 'date' | 'percentage';
}
